module.exports = "@charset \"UTF-8\";\nlabel {\n  float: right;\n  padding-top: 7px; }\nlabel.required:after {\n    content: '✱';\n    color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/components/elements/label/label.component.scss
// module id = ./libs/chassis-core/src/app/resources/components/elements/label/label.component.scss
// module chunks = main